export default function DataDisplayRoute() {
	return <p>Data Display</p>
}
